import { render } from "./FragmentNotFound.vue?vue&type=template&id=f3595eb4"
import script from "./FragmentNotFound.vue?vue&type=script&lang=js"
export * from "./FragmentNotFound.vue?vue&type=script&lang=js"
script.render = render

export default script